<template>
  <v-dialog
    :model-value="visible"
    @update:model-value="onCancel"
    max-width="400"
  >
    <v-card>
      <v-toolbar color="secondary" flat density="compact">
        <v-toolbar-title>
          <v-icon class="text-accent mr-4">mdi-key-variant</v-icon>
          <span class="text-h6 text-accent">
            {{$t("machines.rental.lease.settings.confirm.title")}}
          </span>
        </v-toolbar-title>

        <v-btn icon variant="text" @click="onCancel">
          <v-icon class="text-accent">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pt-6">
        <p class="text-subtitle-1 text-accent">
          {{$t("machines.rental.lease.settings.confirm.description")}}
        </p>
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn class="mr-2 mb-2" @click.stop="onConfirm">{{$t("common.actions.yes")}}</v-btn>
        <v-btn class="mr-2 mb-2" @click.stop="onCancel">{{$t("common.actions.no")}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    visible: false,
    resolve: null,
  }),

  methods: {
    open() {
      this.visible = true

      return new Promise(resolve => {
        this.resolve = resolve
      })
    },
    onConfirm() {
      this.visible = false
      this.resolve(true)
    },
    onCancel() {
      this.visible = false
      this.resolve(false)
    }
  }
}
</script>
